// THIS FILE WAS AUTO GENERATED, UPDATE THE i18n FILES

import { HBinput, i18nLoad } from "@cervval.js/i18n/src/i18n.tools";

export type I18nType = {
    addButton: {
        label: string
    },
    cancelButton: {
        label: string
    },
    closeButton: {
        label: string
    },
    confirmButton: {
        label: string
    },
    deleteButton: {
        label: string
    },
    noButton: {
        label: string
    },
    okButton: {
        label: string
    },
    saveButton: {
        label: string
    },
    toggleVisibility: {
        hide: string,
        show: string
    },
    yesButton: {
        label: string
    }
};

const i18n_en = require("./_en.i18n"); // hash_en=6554382027204540#
const i18n_fr = require("./_fr.i18n"); // hash_fr=2356069158747659#

/** @returns the i18n for provided lang (fallback on app.lang if i18n not found for lang) */
export function i18n(lang?: string): I18nType {
    return i18nLoad<I18nType>(lang, ["en", "fr"], (langToLoad: string) => {
        switch (langToLoad) {
            case "en": return i18n_en;
            case "fr": return i18n_fr;
            default:
        }
        return null;
    });
}